import React, { useState, useEffect, useMemo } from "react";
import { Page, Text, View, Document, Font, Image, StyleSheet, Svg } from "@react-pdf/renderer";
import { fontSize } from "@mui/system";
import { ReactComponent as HEcoA } from "../../../assets/ecoscore/eco_h_a.svg";
import Europe from "../../../assets/analyse/europe.svg";
import countryList from "react-select-country-list";
// import myIcon from 'icons/myIcon.svg'
import { convert_eco_value_to_letter } from "../../../utils/utils.js";

const items = [
  {
    category: "Catégorie d'impact",
    indicator: "Indicateur de catégorie d'impact",
    unit: "Unité",
    model: "Modèle de caractérisation",
  },
  {
    category: "Changement climatique",
    indicator: "Forçage radiatif exprimé en potentiel de réchauffement planétaire (PRP100)",
    unit: "kg CO2 eq",
    model: "Modèle de base sur 100 ans élaboré par le GIEC (basé sur GIEC 2013)",
  },
  {
    category: "Particules fines",
    indicator: "Impact sur la santé humaine",
    unit: "Incidences des maladies",
    model: "Méthode PM recommandée par PNUE (PNUE 2016)",
  },
  {
    category: "Épuisement des ressources en eau",
    indicator: "Potentiel de privation d'eau de l'utilisateur consommation d'eau pondérée en fonction de la privation)",
    unit: "m3 world eq",
    model: "Available WAter REmaining (AWARE) (eau disponible restante) tel que recommandé par PNUE, 2016",
  },
  {
    category: "Épuisement des ressources énergétiques",
    indicator: "Épuisement des ressources abiotiques - combustibles fossiles (ADP-riginefossile)",
    unit: "MJ",
    model: "CML 2002 (Guinée et al., 2002) et van Oers et al., 2002.",
  },
  {
    category: "Usage des terres",
    indicator: "- Indice de qualité du sol105\n- Production biotique\n- Résistance à l'érosion\n- Filtration mécanique\n- Recharge de la nappe phréatique",
    unit: "m3 world eq",
    model: "Available WAter REmaining (AWARE) (eau disponible restante) tel que recommandé par PNUE, 2016",
  },

  {
    category: "Épuisement des ressources - minéraux",
    indicator: "Épuisement des ressources abiotiques (dernièresréservesADP)",
    unit: "kg Sb eq",
    model: "CML 2002 (Guinée et al., 2002) et van Oers et al., 2002.",
  },
  {
    category: "Appauvrissement de la couche d'ozone",
    indicator: "Potentiel d'appauvrissement de la couche d'ozone(PACO)",
    unit: "kg CFC-11 eq",
    model: "PACO constants (OMM 2014 + intégrations)",
  },
  {
    category: "Acidification",
    indicator: "Accumulation d'excédents (AE)",
    unit: "mol H+ eq",
    model: "Accumulation d'excédents (Seppälä et al., 2006; Posch et al, 2008)",
  },
  {
    category: "Radiation ionisante, effet sur la santé",
    indicator: "PEfficacité de l'exposition humaine par rapport à U235otentiel",
    unit: "kBq U235 eq",
    model: "Modèle d'effets sur la santé humaine tel que développé par Dreicer et al., 1995 (Frischknecht et al., 2000)",
  },
  {
    category: "Formation photochimique d'ozone",
    indicator: "Augmentation de la concentration d'ozone de la troposphère",
    unit: "kg NMVOC eq",
    model: "Modèle LOTO-EUROS ( Van Zelm et al. 2008) tel qu'appliqué dans ReCiPe 2008",
  },
  {
    category: "Eutrophisation, terrestre",
    indicator: "Accumulation d'excédents (AE)",
    unit: "mol N eq",
    model: "Accumulation d'excédents (Seppälä et al., 2006; Posch et al, 2008)",
  },
  {
    category: "Eutrophisation, marine",
    indicator: "Fraction de nutriments atteignant le compartiment final marin (N)",
    unit: "kg N eq",
    model: "Modèle EUTREND (Struijs et al., 2009) tel qu'appliqué dans ReCiPe",
  },
  {
    category: "Eutrophisation, eau douce",
    indicator: "Fraction de nutriments atteignant le compartiment final des eauxdouces(P)",
    unit: "kg P eq",
    model: "Modèle EUTREND (Struijs et al., 2009) tel qu'appliqué dans ReCiPe",
  },
  {
    category: "Ecotoxicité d'eau douce",
    indicator: "Unité toxique comparative pour les écosystèmes (CTUe)",
    unit: "mol H+ eq",
    model: "Modèle USEtox 2.1 (Fankte et al., 2017)",
  },
  {
    category: "Toxicité humaine cancérigène",
    indicator: "Unité toxique comparative pour les êtres humains (CTUh)",
    unit: "CTUh",
    model: "Modèle USEtox 2.1 (Fankte et al., 2017)",
  },
  {
    category: "Toxicité humaine non-cancérigène",
    indicator: "Unité toxique comparative pour les êtres humains (CTUh)",
    unit: "CTUh",
    model: "Modèle USEtox 2.1 (Fankte et al., 2017)",
  },
];

// Create styles
const styles = StyleSheet.create({
  cover_page: {
    flexDirection: "row",
    backgroundColor: "white",
    // padding: 20,
    padding: 40,
    // justifyContent: "center",
    // alignItems: "center",
    // alignContent: "center",
    // paddingRight: 80,
  },
  page: {
    flexDirection: "row",
    backgroundColor: "white",
    padding: 40,
    // paddingRight: 80,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  results_container: {
    width: 200,
    flexDirection: "row",
    justifyContent: "center",
    // backgroundColor: "#318734",
    alignItems: "center",
    alignContent: "space-between",
  },

  summary_header: {
    fontSize: 18,
    fontWeight: "extrabold",
    fontFamily: "Helvetica-Bold",
  },
  summary_title: {
    fontWeight: "extrabold",
    fontSize: 11,
    fontFamily: "Helvetica-Bold",
  },
  summary_sub_title: {
    fontWeight: "light",
    fontSize: 11,
    fontFamily: "Helvetica",
  },

  paraph_title: {
    fontSize: 16,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
  },
  paraph_sub_title: {
    fontSize: 13,
  },
  paraph_sub_title_bold: {
    fontSize: 13,
    fontFamily: "Helvetica-Bold",
  },
  paraph_body: {
    fontSize: 11,
  },
  paraph_container_2: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingRight: 60,
  },

  // TABLE HEADER
  table_row: {
    flexDirection: "row",
    alignItems: "center",
    // border: "1px solid black",
  },

  // IMPACT INDICATORS
  table_categorie: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_unit: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_indicateur: {
    width: "35%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_model: {
    width: "35%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },

  // ANALYSIS RESUME
  table_reference: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_product_name: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_type: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_eco_score: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_score_ef: {
    width: "20%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },

  // ANALYSIS INGREDIENTS
  table_row_ingredients: {
    flexDirection: "row",
    alignItems: "center",
    // border: "1px solid black",
  },
  table_step_ingredients: {
    width: "50%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_quantity_ingredients: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  // table_origin_ingredients: {
  //   width: "10%",
  //   height: "100%",
  //   fontSize: 11,
  //   border: "1px solid black",
  //   padding: 4,
  // },
  table_impact_ingredients: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_unique_score_ingredients: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_validate_ingredients: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },

  //  ANALYSIS RESULTS
  table_step: {
    width: "50%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_quantity: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_impact: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_unique_score: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },
  table_validate: {
    width: "10%",
    height: "100%",
    fontSize: 11,
    border: "1px solid black",
    padding: 4,
  },

  //   viewer: {
  //     width: window.innerWidth,
  //     height: window.innerHeight,
  //   },
});

const get_eco_score_icon = (eco_score) => {
  switch (true) {
    case eco_score >= 80:
      return <Image style={{ width: 120, objectFit: "contains", marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/eco_A.png")} />;
    case eco_score <= 80 && eco_score >= 60:
      return <Image style={{ width: 120, objectFit: "contains", marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/eco_B.png")} />;
    case eco_score <= 60 && eco_score >= 40:
      return <Image style={{ width: 120, objectFit: "contains", marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/eco_C.png")} />;
    case eco_score <= 40 && eco_score >= 20:
      return <Image style={{ width: 120, objectFit: "contains", marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/eco_D.png")} />;
    case eco_score <= 20:
      return <Image style={{ width: 120, objectFit: "contains", marginVertical: 15, marginHorizontal: 20 }} src={require("../../../assets/report/eco_E.png")} />;
    default:
      return;
  }
};

const get_eco_score_icon_h = (eco_score) => {
  switch (true) {
    case eco_score >= 80:
      return <Image style={{ objectFit: "contains" }} src={require("../../../assets/report/eco_h_a.png")} />;
    case eco_score <= 80 && eco_score >= 60:
      return <Image style={{ objectFit: "contains" }} src={require("../../../assets/report/eco_h_b.png")} />;
    case eco_score <= 60 && eco_score >= 40:
      return <Image style={{ objectFit: "contains" }} src={require("../../../assets/report/eco_h_c.png")} />;
    case eco_score <= 40 && eco_score >= 20:
      return <Image style={{ objectFit: "contains" }} src={require("../../../assets/report/eco_h_d.png")} />;
    case eco_score <= 20:
      return <Image style={{ objectFit: "contains" }} src={require("../../../assets/report/eco_h_e.png")} />;
    default:
      return;
  }
};

const get_eco_score_icon_f = (eco_score) => {
  switch (true) {
    case eco_score >= 80:
      return <Image style={{ width: 80, objectFit: "contains", marginVertical: 15 }} src={require("../../../assets/report/eco_f_a.png")} />;
    case eco_score <= 80 && eco_score >= 60:
      return <Image style={{ width: 80, objectFit: "contains", marginVertical: 15 }} src={require("../../../assets/report/eco_f_b.png")} />;
    case eco_score <= 60 && eco_score >= 40:
      return <Image style={{ width: 80, objectFit: "contains", marginVertical: 15 }} src={require("../../../assets/report/eco_f_c.png")} />;
    case eco_score <= 40 && eco_score >= 20:
      return <Image style={{ width: 80, objectFit: "contains", marginVertical: 15 }} src={require("../../../assets/report/eco_f_d.png")} />;
    case eco_score <= 20:
      return <Image style={{ width: 80, objectFit: "contains", marginVertical: 15 }} src={require("../../../assets/report/eco_f_e.png")} />;
    default:
      return;
  }
};

const get_eco_score_letter = (eco_score) => {
  switch (true) {
    case eco_score >= 80:
      return "A";
    case eco_score <= 80 && eco_score >= 60:
      return "B";
    case eco_score <= 60 && eco_score >= 40:
      return "C";
    case eco_score <= 40 && eco_score >= 20:
      return "D";
    case eco_score <= 20:
      return "E";
    default:
      return;
  }
};

const get_impact_step_image = (step_name) => {
  switch (true) {
    case step_name === "Recette":
      return <Image style={{ width: 20, objectFit: "contains" }} src={require("../../../assets/report/receip.png")} />;
    case step_name === "Packaging":
      return <Image style={{ width: 20, objectFit: "contains" }} src={require("../../../assets/report/packaging.png")} />;
    case step_name === "Distribution":
      return <Image style={{ width: 20, objectFit: "contains" }} src={require("../../../assets/report/distribution.png")} />;
    case step_name === "Vente au détail":
      return <Image style={{ width: 19, objectFit: "contains" }} src={require("../../../assets/report/selling.png")} />;
    case step_name === "Consommation":
      return <Image style={{ width: 17, objectFit: "contains" }} src={require("../../../assets/report/consumption.png")} />;
    default:
      return;
  }
};

const impact_by_step = [
  {
    step_name: "Recette",
    impact_percent: 70,
  },
  {
    step_name: "Packaging",
    impact_percent: 14,
  },
  {
    step_name: "Distribution",
    impact_percent: 20,
  },
  {
    step_name: "Vente au détail",
    impact_percent: 93,
  },
  {
    step_name: "Consommation",
    impact_percent: 70,
  },
];

const renderFlag = (item, width) => {
  switch (item) {
    case "RoW":
      return <Image style={{ width: width, objectFit: "contains" }} src={require("../../../assets/report/globe.png")} />;
    case "GLO":
      return <Image style={{ width: width, objectFit: "contains" }} src={require("../../../assets/report/globe.png")} />;
    case "RER":
      return <Image style={{ width: width, objectFit: "contains" }} src={require("../../../assets/report/europe.png")} />;
    case "NAN":
      return <Image style={{ width: width, objectFit: "contains" }} src={require("../../../assets/report/circle.png")} />;
    default:
      // return <Image style={{ width: width }} src={"https://countryflagsapi.com/png/" + item.toLowerCase()} />;
      return <Image style={{ width: width, objectFit: "contains" }} src={"https://flagcdn.com/w640/" + item.toLowerCase() + ".png"} />;
    // return <Image style={{ width: width }} src={"https://github.com/hampusborgos/country-flags/blob/main/png250px/" + item.toLowerCase() + ".png"} />;
  }
};


// Create Document Component
const EcoKitTool = (props) => {
  const get_step_results_view = (idx) => {
    return (
      <>
        <View style={styles.table_row} key={"results_header"}>
          <Text style={styles.table_step}>{""}</Text>
          <Text style={styles.table_quantity}>{"Quantité"}</Text>
          <Text style={styles.table_quantity}>{"Catégorie"}</Text>
          <Text style={styles.table_impact}>{"% impact"}</Text>
          <Text style={styles.table_unique_score}>{"Score EF"}</Text>
          <Text style={styles.table_validate}>{"Validé à l'analyse"}</Text>
        </View>
        {props.analysis_steps_results &&
          props.analysis_steps_results[idx].data.map((y, i) => {
            return y.optimization_results ? (
              <>
                <View style={styles.table_row_ingredients} key={"transport_header" + i}>
                  <Text style={{ ...styles.table_step_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{"---" + y.custom_analysis.flow_name}</Text>
                  <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{parseFloat(y.custom_analysis.quantity).toFixed(2) + " " + y.custom_analysis.unit}</Text>
                  <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{y.custom_analysis.k_type}</Text>
                  <Text style={{ ...styles.table_impact_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{y.custom_analysis.percent_impact + "%"}</Text>
                  <Text style={{ ...styles.table_unique_score_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{parseFloat(y.custom_analysis.score_unique).toFixed(2) + " mPt"}</Text>
                  <Text style={{ ...styles.table_validate_ingredients, ...{ backgroundColor: "#CFEBE2" } }}>{y.custom_analysis.checked ? "Oui" : "Non"}</Text>
                </View>
                <View style={styles.table_row_ingredients} key={"transport_header" + i}>
                  <Text style={{ ...styles.table_step_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{"---" + y.optimization_results.flow_name}</Text>
                  <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>
                    {parseFloat(y.optimization_results.quantity).toFixed(2) + " " + y.optimization_results.unit}
                  </Text>
                  <Text style={{ ...styles.table_quantity_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{y.optimization_results.k_type}</Text>
                  <Text style={{ ...styles.table_impact_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{y.optimization_results.percent_impact + "%"}</Text>
                  <Text style={{ ...styles.table_unique_score_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{parseFloat(y.optimization_results.score_unique).toFixed(2) + " mPt"}</Text>
                  <Text style={{ ...styles.table_validate_ingredients, ...{ backgroundColor: "#FFF7E3" } }}>{y.optimization_results.checked ? "Oui" : "Non"}</Text>
                </View>
              </>
            ) : (
              <View style={styles.table_row_ingredients} key={"transport_header" + i}>
                <Text style={styles.table_step_ingredients}>{y.flow_name}</Text>
                <Text style={styles.table_quantity_ingredients}>{parseFloat(y.quantity).toFixed(2) + " " + y.unit}</Text>
                <Text style={styles.table_quantity_ingredients}>{y.k_type}</Text>
                <Text style={styles.table_impact_ingredients}>{y.percent_impact + "%"}</Text>
                <Text style={styles.table_unique_score_ingredients}>{parseFloat(y.score_unique).toFixed(2) + " mPt"}</Text>
                <Text style={styles.table_validate_ingredients}>{y.checked ? "Oui" : "Non"}</Text>
              </View>
            );
          })}
      </>
    );
  };

  return (
    <Document>
      {/* style={styles.cover_page} */}
      <Page size={[1080, 1920]} orientation="landscape">
        <View style={{ flex: 1, flexDirection: "row" }}>
          {/* SECTION_1 */}
          <View style={{ flex: 1 }}>
            {/* HEADER */}
            <View style={{ flex: 0.225, padding: 40 }}>
              <Text style={{ fontSize: 52, fontFamily: "Helvetica-Bold" }}>Kit de communication{"\n"}éco-score</Text>

              <View style={{ flexDirection: "row", flex: 1, marginTop: 20 }}>
                <View style={{ flex: 0.7 }}>
                  <Text style={{ fontSize: 18, justifyContent: "center", alignItems: "center", alignContent: "center" }}>
                    Nom du produit : {props.product_name}
                    {"\n"}
                    {"\n"}
                  </Text>
                  {/* <View style={{ justifyContent: "center", alignItems: "center", alignContent: "center" }}> */}
                  <Text style={{ fontSize: 18, fontWeight: "light" }}>Référence du produit :</Text>
                  <Text style={{ fontSize: 18, fontWeight: "light" }}>{props.product_ref}</Text>
                </View>
                {/* </View> */}

                <View style={{ flex: 0.3 }}>
                  <Text style={{ fontSize: 18, fontWeight: "light" }}>
                    Version : {"1.0.0"}
                    {"\n"}
                    {"\n"}
                  </Text>
                  <Text style={{ fontSize: 18, fontWeight: "light" }}>Valide pendant 8 mois.</Text>
                </View>
              </View>
            </View>

            {/* PICTO */}
            <View style={{ flex: 0.325, backgroundColor: "#C6EDDF", flexDirection: "row", alignContent: "center", alignItems: "center", padding: 40 }}>
              <View style={{ flex: 1 }}>
                <Text style={{ fontSize: 42, fontFamily: "Helvetica-Bold" }}>Pictogramme éco-score</Text>
                <Text style={{ marginTop: 20 }}>
                  Le produit "{props.product_name}" obtient{"\n"}l'éco-score {convert_eco_value_to_letter(props.eco_score)} suite à une Analyse du Cycle de Vie{"\n"}réalisée avec le logiciel Lokalité. 👏
                </Text>
              </View>

              <View style={{ flex: 1, flexDirection: "row" }}>
                <View style={{ flex: 1 }}>{get_eco_score_icon(props.eco_score)}</View>

                <View style={{ flex: 1, marginLeft: -30 }}>
                  <View style={{ flex: 1 }}>{get_eco_score_icon_h(props.eco_score)}</View>
                  <View style={{ flex: 1 }}>{get_eco_score_icon_f(props.eco_score)}</View>
                </View>
              </View>
            </View>

            {/* STEP_IMPACT */}
            <View style={{ flex: 0.45, flexDirection: "row", padding: 40, alignItems: "center", paddingTop: 10 }}>
              <View style={{ flex: 0.55 }}>
                <View style={{ borderWidth: 1, borderColor: "#E2E6EA", borderRadius: 20, marginRight: 38, padding: 5 }}>
                  {props.impact_by_step.map((x) => (
                    <View style={{ flexDirection: "row", padding: 10, justifyContent: "space-between" }}>
                      <View style={{ flex: 0.6, flexDirection: "row", alignItems: "center" }}>
                        <View style={{ marginRight: 12 }}>{get_impact_step_image(x.step_name)}</View>
                        <Text style={{}}>{x.step_name}</Text>
                      </View>

                      <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "flex-end", alignContent: "flex-end", alignSelf: "flex-end" }}>
                        <Text style={{ marginRight: 10 }}>{x.impact_percent + "%"}</Text>
                        <View style={{ width: 100, backgroundColor: "#E2E6EA", height: 5, borderRadius: 10 }}>
                          <View style={{ width: x.impact_percent + "%", backgroundColor: "#BDC4CB", height: 5, borderRadius: 10 }} />
                        </View>
                      </View>
                    </View>
                  ))}
                </View>
              </View>

              <View style={{ flex: 0.45 }}>
                <Text style={{ fontSize: 42, fontFamily: "Helvetica-Bold" }}>Impact par étape de Cycle de Vie</Text>
                <Text style={{ marginTop: 20 }}>
                  Distribution de l'impact environnemental{"\n"}unique, pondérant les 16 indicateurs d'impact{"\n"}de la Commission Européenne.
                </Text>
                <Text style={{ marginTop: 13 }}>* Voir le rapport d'analyse pour consulter le{"\n"}détails des indicateurs d'impact.</Text>
              </View>
            </View>
          </View>

          {/* SECTION_2 */}
          <View style={{ flex: 1, backgroundColor: "#F3F5F7" }}>
            {/* ORIGIN */}
            <View style={{ flex: 0.3, flexDirection: "row", alignContent: "center", alignItems: "center", padding: 40 }}>
              <View style={{ flex: 1 }}>
                <Text style={{ fontSize: 42, fontFamily: "Helvetica-Bold" }}>Origine</Text>
                <Text style={{ fontSize: 26, marginTop: 32 }}>Tout processus confondus{"\n"}</Text>
                <Text style={{ marginTop: 14 }}>
                  Toutes étapes de cycle de vie confondu, le{"\n"}produit "{props.product_name}" est {props.ingredient_origin[0].percent + "% d'origine"}{"\n"} {props.ingredient_origin[0].name}.
                </Text>
              </View>

              <View style={{ flex: 1, alignItems: "flex-end" }}>
                {props.ingredient_origin &&
                  props.ingredient_origin.slice(0, 2).map((x, index) => (
                    <View style={{ flexDirection: "row", padding: 20, alignContent: "center" }}>
                      <View style={{ marginRight: 20, justifyContent: "center", alignItems: "flex-end", alignContent: "center" }}>
                        <Text style={{ flex: 1, fontFamily: "Helvetica-Bold", fontSize: 30 - 5 ** index, alignContent: "center", alignItems: "center", justifyContent: "center" }}>{x.name}</Text>
                        <Text style={{ flex: 1, fontFamily: "Helvetica-Bold", fontSize: 61 - 10 ** index, alignContent: "center", alignItems: "center", justifyContent: "center" }}>
                          {x.percent + "%"}
                        </Text>
                      </View>
                      <View style={{}}>{renderFlag(x.origin, 160 - 25 ** index)}</View>
                    </View>
                  ))}
              </View>
            </View>


            {/* EQ_IMPACT */}
            <View style={{ flex: 0.35, padding: 40, paddingTop: -5 }}>
              <Text style={{ fontSize: 42, fontFamily: "Helvetica-Bold" }}>Équivalent d'impact{"\n\n"}</Text>
              <View style={{ height: 198, width: 623, borderWidth: 1, borderColor: "#E2E6EA", alignContent: "center", borderRadius: 20, marginRight: 58, backgroundColor: "white" }}>
                <View style={{ flexDirection: "row", height: 198 }}>
                  {/* <View style={{ flexDirection: "row" }}> */}
                  <View style={{ flex: 1 }}>
                    {props.eq_impact.slice(0, 3).map((x) => (
                      <View style={{ flexDirection: "row", flex: 1 }}>
                        <View style={{ flex: 0.2, flexDirection: "row", alignItems: "center", padding: 20 }}>
                          {/* <View style={{ marginRight: 12 }}>{get_impact_step_image(x.step_name)}</View> */}
                          <Image style={{ height: 32, objectFit: "contains" }} src={require("../../../assets/report/" + x.name + ".png")} />;
                        </View>

                        <View style={{ flex: 0.8, flexDirection: "row", alignItems: "center", padding: 20 }}>
                          <Text style={{ marginRight: 10, fontFamily: "Helvetica-Bold" }}>{x.value + " " + x.unit}</Text>
                        </View>
                      </View>
                    ))}
                  </View>

                  <View style={{ flex: 1 }}>
                    {props.eq_impact.slice(3, 6).map((x) => (
                      <View style={{ flexDirection: "row", flex: 1 }}>
                        <View style={{ flex: 0.2, flexDirection: "row", alignItems: "center", padding: 20 }}>
                          {/* <View style={{ marginRight: 12 }}>{get_impact_step_image(x.step_name)}</View> */}
                          <Image style={{ height: 32, objectFit: "contains" }} src={require("../../../assets/report/" + x.name + ".png")} />;
                        </View>

                        <View style={{ flex: 0.8, flexDirection: "row", alignItems: "center", padding: 20 }}>
                          <Text style={{ marginRight: 10, fontFamily: "Helvetica-Bold" }}>{x.value + " " + x.unit}</Text>
                          <Text style={{}}>{" " + x.text}</Text>
                        </View>
                      </View>
                    ))}
                  </View>
                  {/* </View> */}
                </View>
              </View>
            </View>

            {/* MEAN_DIFF */}
            <View style={{ flex: 0.35, padding: 40, paddingTop: -25 }}>
              <Text style={{ fontSize: 42, fontFamily: "Helvetica-Bold" }}>Différence par rapport à la moyenne{"\n\n"}</Text>
              <View style={{ height: 198, width: 623, borderWidth: 1, borderColor: "#E2E6EA", alignContent: "center", borderRadius: 20, marginRight: 58, backgroundColor: "white" }}>
                {props.impact_diff.slice(0, 3).map((x) => (
                  <View style={{ flexDirection: "row", flex: 1, padding: 20 }}>
                    {/* <View style={{ flex: 1, flexDirection: "row", alignItems: "center", padding: 20 }}> */}
                    <View style={{ marginRight: 12, width: 36 }}>
                      <Image style={{ height: 32,  }} src={require("../../../assets/report/" + x.name + ".png")} />;
                    </View>
                    <Text style={{}}>{x.value >= 0 ? "Au moins " + x.value + "% " + x.text + " en moins." : "Au moins " + Math.abs(x.value) + "% " + x.text + " en plus."}</Text>
                    {/* </View> */}

                    {/* <View style={{ flex: 0.4, flexDirection: "row", alignItems: "center", padding: 20 }}>
                      <Text style={{ marginRight: 10 }}>{x.impact_percent + "%"}</Text>
                      <View style={{ width: 100, backgroundColor: "#E2E6EA", height: 5, borderRadius: 10 }}>
                        <View style={{ width: x.impact_percent + "%", backgroundColor: "#BDC4CB", height: 5, borderRadius: 10 }} />
                      </View>
                    </View> */}
                  </View>
                ))}
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
export default EcoKitTool;
